import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import coinsuranceService from "./coinsuranceService";
import { flashMessage as flash } from "../../../utils/flash";

const initialState = {
  isLoading: false,
  isSuccess: false,
  coinsuranceData: null,
  singleCoinsuranceData: null,
};

export const coinsuranceSlice = createSlice({
  name: "coinsurance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // add coinsurance
      .addCase(addCoinsurance.pending, (state) => {
        state.pending = true;
      })
      .addCase(addCoinsurance.fulfilled, (state, action) => {
        state.pending = false;
        if (!action.payload.errors) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(addCoinsurance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllCoinsurace.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCoinsurace.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.coinsuranceData = payload.AllCoInsurance;
      })
      .addCase(getAllCoinsurace.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      .addCase(getSingleCoinsurance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSingleCoinsurance.fulfilled, (state, { payload }) => {
        state.isLoading = false;

        state.singleCoinsuranceData = payload;
      })
      .addCase(getSingleCoinsurance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // update single coinsurance
      .addCase(updateSingleCoinsurance.pending, (state) => {
        state.pending = true;
      })
      .addCase(updateSingleCoinsurance.fulfilled, (state, action) => {
        state.pending = false;
        if (!action.payload.errors) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updateSingleCoinsurance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

// add coinsurance
export const addCoinsurance = createAsyncThunk(
  "/coinsurance/add",
  async (data, thunkAPI) => {
    try {
      return await coinsuranceService.addCoinsurance(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get all coinsurace

export const getAllCoinsurace = createAsyncThunk(
  "getAllCoinsurace",
  async (DATA, thunkAPI) => {
    try {
      return await coinsuranceService.getAllCoinsurace(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get single coinsurance

export const getSingleCoinsurance = createAsyncThunk(
  "getSingleCoinsurance",
  async (id, thunkAPI) => {
    try {
      return await coinsuranceService.getSingleCoinsurance(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//update single coinsurance

export const updateSingleCoinsurance = createAsyncThunk(
  "updateSingleCoinsurance",
  async (data, thunkAPI) => {
    try {
      return await coinsuranceService.updateSingleCoinsurance(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const {} = coinsuranceSlice.actions;

export default coinsuranceSlice.reducer;
